var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEffectiveCommunication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_71",
    "data-name": "Group 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76.886,
    height: 87.23,
    viewBox: "0 0 76.886 87.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 76.886,
    height: 87.23,
    fill: "#dd4633"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M75.732,0A15.9,15.9,0,0,1,87.218,7.51a15.354,15.354,0,0,1-13.19,23.157V42.082L60.391,30.76h-8.5L38.25,42.082V30.667A15.36,15.36,0,0,1,26.157,5.881,16.361,16.361,0,0,1,36.546,0ZM48.472,12.778H43.361v5.111h5.111Zm10.222,0H53.583v5.111h5.111Zm10.222,0H63.806v5.111h5.111Z",
    transform: "translate(-17.695)",
    fill: "#dd4633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M.11,244.87c.254-4.291-.338-8.963-.006-13.21.254-3.26,3.243-7.235,6.736-7.235h9.967l-2.474-.678c-11.57-4.672-6.521-22.075,5.888-19.517,9.841,2.029,10.775,16,1.446,19.517l-2.474.678h9.967c3.49,0,6.482,3.972,6.736,7.235.331,4.248-.259,8.918-.006,13.21Z",
    transform: "translate(0 -157.64)",
    fill: "#dd4633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M180.11,244.87c.254-4.291-.338-8.963-.006-13.21.254-3.26,3.243-7.235,6.736-7.235h9.967l-2.474-.678c-11.57-4.672-6.521-22.075,5.888-19.517,9.841,2.029,10.775,16,1.446,19.517l-2.474.678h9.967c3.49,0,6.482,3.972,6.736,7.235.331,4.248-.259,8.918-.006,13.21Z",
    transform: "translate(-139.111 -157.64)",
    fill: "#dd4633"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffectiveCommunication);
export default __webpack_public_path__ + "static/media/effective_communication.6663da9636d0e95ffe5fc73d163bbebe.svg";
export { ForwardRef as ReactComponent };